<template>
  <div>
    <editor :name="name" :value="obj.text" :placeholder="placeholder" :substitution-tags="substitutionTags" @input="updateContents"></editor>
  </div>
</template>

<script>
import Editor from '../TrixEdit'

export default {
  name: 'ContentText',

  components: {
    Editor
  },

  data() {
    return {
      name: 'editor',
      placeholder: 'Editor Text goes here'
    }
  },

  props: [
    'obj',
    'substitutionTags'
  ],

  methods: {
    addSubstitution(e) {
      this.obj.text += e.target.value
      e.target.value = null
    },

    updateContents(e) {
      this.obj.text = e
    }
  }
}
</script>

<style scoped>
  textarea {
    width: 100%;
    height: 150px;
  }
</style>
